import { jsxs as i, jsx as e, Fragment as p } from "react/jsx-runtime";
import { ad as r, ae as h } from "../../vendor-EQDp64ng.js";
import { forwardRef as x } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as o } from "../BaseIcon/index.js";
import '../../assets/index16.css';const f = "_checkboxWrapper_h34x1_1", k = "_checkbox_h34x1_1", _ = "_indicator_h34x1_37", c = {
  checkboxWrapper: f,
  checkbox: k,
  indicator: _
}, W = x(
  ({ children: t, labelRef: n, variant: a = "checkbox", ...s }, d) => {
    const m = r(d), b = r(n);
    return /* @__PURE__ */ i(
      h,
      {
        ...l(s),
        ref: b,
        inputRef: m,
        className: c.checkboxWrapper,
        "data-component": "Checkbox",
        children: [
          /* @__PURE__ */ e("div", { className: c.checkbox, "aria-hidden": !0, children: a === "visibility" ? /* @__PURE__ */ i(p, { children: [
            /* @__PURE__ */ e(o, { size: "md", color: "moon", icon: "visibility-checked" }),
            /* @__PURE__ */ e(o, { size: "md", color: "moon", icon: "visibility-unchecked" }),
            /* @__PURE__ */ e(o, { size: "md", color: "moon", icon: "visibility-indeterminate" })
          ] }) : /* @__PURE__ */ e("div", { className: c.indicator }) }),
          t
        ]
      }
    );
  }
);
export {
  W as Checkbox
};
